import React, { useRef, useId } from 'react'
import DOMPurify from 'dompurify'

export default function PopoverTooltip({ children, content, className = '' }) {
  const popoverRef = useRef(null)
  const anchorId = useId().replace(/[^a-zA-Z0-9]/g, '')
  const hideTimer = useRef(null)

  const scheduleHide = () => {
    hideTimer.current = setTimeout(() => popoverRef.current?.hidePopover(), 100)
  }

  const cancelHide = () => clearTimeout(hideTimer.current)

  const popoverStyle = {
    positionAnchor: `--t${anchorId}`,
    positionArea: 'bottom right',
    margin: 0,
    border: 'none',
    maxWidth: '220px',
    transform: 'translate(-10px, 3px)'
  }

  return (
    <>
      <span
        className={className}
        style={{ anchorName: `--t${anchorId}`, cursor: 'default' }}
        tabIndex={0}
        onMouseEnter={() => { cancelHide(); popoverRef.current?.showPopover() }}
        onMouseLeave={scheduleHide}
        onFocus={() => { cancelHide(); popoverRef.current?.showPopover() }}
        onBlur={scheduleHide}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); popoverRef.current?.showPopover() }
          if (e.key === 'Escape') scheduleHide()
        }}
      >
        {children}
      </span>
      <div
        ref={popoverRef}
        popover="manual"
        className='dome-rounded-border dome-padding6-12 dome-bg-fill dome-light-shadow dome-p3'
        style={popoverStyle}
        onMouseEnter={cancelHide}
        onMouseLeave={scheduleHide}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
      />
    </>
  )
}
